import * as React from 'react';

import SkillSetsPageNotConfigurable from 'bundles/unified-home-common/components/enterprise/SkillSetsPageNotConfigurable';

const EnterpriseSkillSetsPageRootContent = () => {
  return (
    <div data-testid="enterprise-skill-sets-page">
      <SkillSetsPageNotConfigurable />
    </div>
  );
};

export default EnterpriseSkillSetsPageRootContent;
